module.exports = __webpack_public_path__ + "img/result-btn_txt.37d4c68e.png";